import React, { useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router";

// layouts
import { MainLayout } from "layouts";

// components
import { ImageSettingsEditForm } from "components/all/settings";
import { Loading } from "components/common";
import Text from "components/ui/Text";

const ImageSettings = () => {
  const location = useLocation();
  const { partner, partnerBranch } = location.state;
  const [loading, setLoading] = useState(false);

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "센터 이미지 설정" }}
    >
      {loading && <Loading />}
      <CenterBox>
        <Text
          display="block"
          color="primary100"
          fontSize="14px"
          fontWeight="500"
          lineHeight="18px"
        >
          {partner} {partnerBranch}
        </Text>
      </CenterBox>
      <ImageSettingsEditForm
        info={location.state}
        loading={loading}
        setLoading={setLoading}
      />
    </MainLayout>
  );
};

const CenterBox = styled.div`
  background: #eef5ff;
  border-radius: 6px;
  margin: 12px 20px;
  padding: 12px 0;
  text-align: center;
`;

export default ImageSettings;
